"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _exponent = _interopRequireDefault(require("./exponent.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default(step) {
  return Math.max(0, -(0, _exponent.default)(Math.abs(step)));
}


//////////////////
// WEBPACK FOOTER
// ./~/victory-vendor/lib-vendor/d3-format/src/precisionFixed.js
// module id = 6850
// module chunks = 0